/**
 * Created by alex.y on 8/31/2017.
 */
export class Duty{
    public Measure: string;
    public Value: number;
    public DutyType:DutyType;
    public Quantity: number;
    public ExtraDuties: Duty[] = [];

    public constructor(obj?: Partial<Duty>){
        Object.assign(this, obj);
    }
}

export enum DutyType{
    Percent = 0,
    PerItem,
    Sugar = 2,

    Less = 3,
    More = 4,
    LessTariff = 5,
    Degree = 6,
    Plus = 7,
    None = 8,
    Manual = 9
}




// WEBPACK FOOTER //
// ./app/objects/calculator/duty.ts